import { render, staticRenderFns } from "./PhsLogsListPage.vue?vue&type=template&id=527bb2ef"
import script from "./PhsLogsListPage.vue?vue&type=script&lang=js"
export * from "./PhsLogsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports